import { render, staticRenderFns } from "./PacketDetail.vue?vue&type=template&id=37baffe4&scoped=true"
import script from "./PacketDetail.vue?vue&type=script&lang=js"
export * from "./PacketDetail.vue?vue&type=script&lang=js"
import style0 from "./PacketDetail.vue?vue&type=style&index=0&id=37baffe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37baffe4",
  null
  
)

export default component.exports